export default "__VITE_ASSET__d4397fd4__"